module.exports = __webpack_public_path__ + "img/17.88c91e90.jpg";